import { UserRoles } from '@account-users/account/models';

export interface IUserRole {
  id: number;
  code: UserRoles;
  displayName?: string;
  type: RoleType;
}

export enum RoleType {
  User = 'User',
  AccountUser = 'AccountUser',
}
